/* ------------------------------------------------------------------ *
 * شلم's FELT GEOMETRY shared by the table (`ShelemTable.tsx`) and the parts drawn on its felt
 * (`shelem-auction.tsx`): one definition each, so a part can never place itself against a seat
 * that is drawn somewhere else.
 * ------------------------------------------------------------------ */

/*
 * A SIDE SEAT'S NAME BOX stops short of the side card in front of it — بی‌دل's cap, because شلم's
 * trick slots are its (and حکم's) diamond: the side card reaches 91.7 px from the felt's centre (its
 * 64 px slot + 27.7 px of a 4°-tilted card), the box starts 16 px in from the table's edge, so it may
 * be `half the table − 16 − 91.7 − 2` wide: `min(50vw, 220px) − 110px` — 92 px from 404 px up, 50 at
 * 320 — floored at 41 px, where «در حال» (a wrapped notice's first line) still fits. Inline, not a
 * Tailwind class: a `clamp()` in a class name can compile to nothing. The top seat has the felt's
 * width to itself.
 */
export const SIDE_NAME_MAX = "clamp(41px, calc(min(50vw, 220px) - 110px), 92px)";

/** The partner's seat root sits `top-[38px]` in `main`; the felt is inset 12 px. */
export const PARTNER_TOP_IN_FELT = 38 - 12;
export const FELT_INSET = 12;

/** SIDE_NAME_MAX in px, off the felt's width (the table is the felt + 2 × `FELT_INSET`, at most
 *  440 px) — the ONE px form of the clamp above: the trick's reach (`ShelemTable`) and the کف's
 *  corner beside the right seat (`shelem-kaf.tsx`) both read it. */
export function shelemSideNameMaxPx(feltW: number): number {
  return Math.min(92, Math.max(41, Math.min((feltW + 2 * FELT_INSET) / 2, 220) - 110));
}

/** The face-down کف's cards: a `small` card scaled to this (36×50 → 20×28), fanned this many px a
 *  step — `WidowCorner` (the table) and the کف's flights (`shelem-kaf.tsx`) draw the same four. */
export const WIDOW_SCALE = 0.56;
export const WIDOW_STEP = 6;
